<template>
  <div class="app">
    <div class="main ">
      <Header2 :back="false"/>
      <el-form class="form" ref="form" :model="form" :hide-required-asterisk="true">
        <div class="login-title">
          <h1>{{ $t('account.login_title') }} {{ $t('common.app_name') }}</h1>
        </div>
        <el-form-item prop="username"
          :rules="[{ required: true, message: this.$t('form.place_username'), trigger: 'blur' }]">
          <el-input v-model="form.username" :placeholder="$t('form.place_username')"></el-input>
        </el-form-item>
        <el-form-item prop="password"
          :rules="[{ required: true, message: this.$t('form.place_password'), trigger: 'blur' }]">
          <el-input v-model="form.password" type="password" :show-password="true"
            :placeholder="$t('form.place_password')"></el-input>
        </el-form-item>
        <div class="contact">
          <span @click="openService()">{{ $t('account.contact') }}</span>
        </div>
        <el-button @click="login()" :loading="loading">{{ $t('account.login') }}</el-button>
        <el-button @click="linkWallet()" :loading="loading">{{ $t("common.connectWallet") }}</el-button>
        <div class="reg">
          {{ $t('account.no_account') }}<span @click="$router.push('/register')">{{ $t('account.free_register') }}</span>
        </div>
      </el-form>

      <el-dialog :visible.sync="dialog" width="100%" :fullscreen="true" class="custom-dialog">
        <el-form class="form" ref="form2" :model="form2" :hide-required-asterisk="true">
          <div class="login-title">
            <h1>{{ $t('account.login_title') }} {{ $t('common.app_name') }}</h1>
          </div>
          <el-form-item prop="password"
                        :rules="[{ required: true, message: this.$t('form.place_password'), trigger: 'blur' }]">
            <el-input v-model="form2.password" type="password" :show-password="true"
                      :placeholder="$t('form.place_password')"></el-input>
          </el-form-item>
          <el-button @click="registerAndLogin3()" :loading="loading">{{ $t("common.connectWallet") }}</el-button>
        </el-form>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import Header2 from "@/components/Header2.vue";
import {Loading} from "element-ui";
import {serviceUrl} from "@/api/global";
import {checkUsername} from "@/api/login";


export default {
  components: {
    Header2,
  },
  data() {
    return {
      dialog: false,
      loading: false,
      form: {
        username: undefined,
        password: undefined,
      },
      form2: {
        username: undefined,
        password: undefined,
        walletType: undefined,
      },
      tronWeb: undefined, // tronweb 实例
      userAddress: "", // 当前用户钱包地址
      run: true, // 简单防止重复单击操作
      serviceUrls: serviceUrl
    };
  },
  computed: {

  },
  created() {

  },
  mounted() {

  },
  methods: {
    openService() {
      // this.$router.push("/web")
      window.location.href = this.serviceUrls
    },
    login() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.loading = true;
          this.$store.dispatch("user/login", this.form).then(() => {
            this.$router.push({ path: "/home" });
            this.loading = false;
          }).catch(() => {
            this.loading = false;
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      })
    },
    registerAndLogin2(){
      checkUsername(this.form2.username).then(response => {
        if(response.Data){
          this.form2.password = "123456"
          this.loginWallet()
        }else{
          this.dialog = true
        }
      })
    },
    registerAndLogin3(){
      this.$refs.form2.validate((valid) => {
        if (valid) {
          this.loginWallet()
        } else {
          console.log("error submit!!");
          return false;
        }
      })
    },
    loginWallet(){
      let _this = this;
      _this.loading = true;
      _this.loadingInstance = Loading.service({ fullscreen: true });
      _this.$store.dispatch("user/loginWallet", _this.form2).then(() => {
        _this.$router.push({ path: "/home" });
        _this.loadingInstance.close()
      }).catch(() => {
        _this.loadingInstance.close()
      });
    },
    // 链接钱包
    linkWallet() {
      // this.form2.username = "123456"
      // this.form2.walletType = 1
      // this.registerAndLogin2()
      if (window.tronWeb) {
        this.tronWeb = window.tronWeb;
        this.getAddress()
      } else if (window.ethereum) {
        this.Web3 = window.ethereum;
        window.ethereum.enable().then((res) => {
          // this.$message.success("获取地址成功！")
          this.userAddress = res[0];
          this.form2.username = this.userAddress
          this.form2.walletType = 2
          this.registerAndLogin2()
        })
      } else {
        this.$message(this.$t('common.walletLink'))
      }
    },
    // 获取钱包地址
    getAddress() {
      if (this.run) {
        var _this = this;
        var obj = setInterval(async () => {
          if (window.tronWeb && window.tronWeb.defaultAddress.base58) {
            clearInterval(obj)
            // this.$message.success("获取地址成功！")
            _this.userAddress = window.tronWeb.defaultAddress.base58;
            _this.form2.username = _this.userAddress
            _this.form2.walletType = 1
            _this.registerAndLogin2()
          } else {
            clearInterval(obj)
            this.$message.error("Exception")
          }
        }, 10)
      } else {
        this.$message.error("Error")
      }
    },
  }
}
</script>
<style lang="less" scoped>
@import "./style.less";

.custom-dialog{
  /deep/.el-dialog{
    background: black !important;
  }
}
</style>
